(() => {
  'use strict';
  const dayMs = 86400000;
  const eastern = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric' });
  const readable = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
  function scheduleFor(instant) {
    const parts = Object.fromEntries(eastern.formatToParts(instant).map(p => [p.type, p.value]));
    const today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12);
    const index = (new Date(today).getUTCDay() + 6) % 7;
    const monday = today - index * dayMs;
    const date = offset => readable.format(new Date(monday + offset * dayMs));
    const cookieNext = index >= 2;
    const barkNext = index >= 4;
    const barkStart = barkNext ? 9 : Math.max(2, index + 1);
    return {
      forsyth: date(index >= 3 ? 12 : 5),
      forsythLate: index >= 3 && index <= 5,
      cookies: { start: date(cookieNext ? 9 : 2), end: date(cookieNext ? 10 : 3), late: cookieNext, single: false },
      bark: { start: date(barkStart), end: date(barkNext ? 11 : 4), late: barkNext, single: barkStart === 4 }
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { scheduleFor };
  if (typeof document === 'undefined') return;
  function render() {
    const schedule = scheduleFor(new Date());
    document.querySelectorAll('[data-gg-schedule]').forEach(panel => {
      const pickup = panel.querySelector('[data-gg-forsyth]');
      const text = pickup.dataset[schedule.forsythLate ? 'late' : 'normal'].replace('{date}', schedule.forsyth);
      if (pickup.textContent !== text) pickup.textContent = text;
      pickup.classList.toggle('gg-schedule__late', schedule.forsythLate);
      panel.querySelectorAll('[data-gg-shipping]').forEach(node => {
        const window = schedule[node.dataset.ggShipping];
        const key = window.late ? 'late' : window.single ? 'single' : 'normal';
        const message = node.dataset[key].replace('{start}', window.start).replace('{end}', window.end);
        if (node.textContent !== message) node.textContent = message;
        node.classList.toggle('gg-schedule__late', window.late);
      });
    });
  }
  render();
  setInterval(render, 1000);
  document.addEventListener('visibilitychange', render);
  document.addEventListener('shopify:section:load', render);
})();
